const excludeDrafts = (items = []) =>
  items.filter(item => !item?._id?.startsWith('drafts.'));

export { excludeDrafts };